/* --- STATE --- */

import {
  Tenant,
  User,
  UserCDN,
  UserPermission,
  UserPreferences,
  UserProfile,
} from '@mti/multitenant-ui-shared';
import { Request } from '../AdminPage/types';
import { TabType } from '../Header/types';

export const MOCK_TENANT_ID: string = 'MOCK';

// State for the Login Feature
export interface AuthState {
  isAuthenticated: boolean;
  userProfile: UserProfile;
  userPermissions: UserPermission[];
  authDetails: AuthorizationDetails;
  userCDNs: UserCDN[];
  userPreferences: UserPreferences;
  tenant: Tenant;
  processing: boolean;
  fetchingPermissions: boolean;
  selectedTab: TabType;
  error: AuthErrorMessage | undefined;
  operatorPulseDispatch: Request;
  testsEnabled: boolean;
}

export enum AuthErrorMessage {
  RESPONSE_ERROR = 'RESPONSE_ERROR',
  AUTHENTICATION_FAILED = 'AUTHENTICATION_FAILED',
  INVALID_TENANTID = 'INVALID_TENANTID',
  NO_USER = 'NO_USER',
}

export class AuthenticationError extends Error {}
export class NotAuthorisedError extends Error {}

export interface TenantIDWithExtension {
  tenantId: string;
  operatorExtension: string;
}

export interface UserWithTenant {
  user: User;
  tenant: Tenant;
}

export interface AuthorizationDetails {
  telOpAccess: boolean;
  queryAccess: boolean;
  adminAccess: boolean;
  superAdminAccess: boolean;
  supervisorAccess: boolean;
  messagingAccess: boolean;
  mapAccess: boolean;
}

export enum LanguageType {
  ENGLISH = 'en-US',
  FINNISH = 'fi-FI',
  CHINESE = 'zh-CH',
}

export type ContainerState = AuthState;
